module.exports = __webpack_public_path__ + "static/media/Data.7022385e.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/HomePage/Data.png
// module id = 1058
// module chunks = 0